@let isCustomDeleted = isDisabled() && getCustomValueState('id');

<mat-expansion-panel
  class="cta-expansion-panel"
  [class.analytics-mode-panel]="analyticsMode()"
  [class.view-mode]="isViewMode()"
  [disabled]="isCustomDeleted || analyticsMode()"
  [expanded]="(isPanelExpanded() && !isCustomDeleted) || analyticsMode()"
  [hideToggle]="analyticsMode()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title>
      <div class="flex flex-1 justify-between items-center">
        <app-editable-title
          fontClasses="font-bold"
          [class.text-sm]="!analyticsMode()"
          [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
          [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
          [iconSize]="16"
          [subtitle]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.gamePlayDeliverable.subtitle' | translate"
          [control]="name"
          [isViewMode]="isViewMode()"
          [disabled]="isCustomDeleted"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
          [infoTooltip]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptions.gamePlay' | translate"
          [creatorBriefingMode]="creatorBriefingMode()"
          [showRequiredBadge]="showRequiredBadge()"
        />

        @if (!isViewMode()) {
          <div class="flex items-center gap-7">
            <app-deliverable-advanced-button
              [platformFeature]="platformFeature()"
              [deliverableType]="form().value.type"
              [isOpen]="showAdvancedSettings()"
              (toggled)="onToggleAdvancedSettings()"
            />

            <div class="flex items-center">
              @if (isCustomMode() && !form().value.exclusiveTo) {
                <app-custom-remove-button
                  [checked]="!getCustomValueState('id')"
                  (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                  #deleteParentButton
                />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-transparent-button-color"
                  (click)="onDeleteClick(form().value.exclusiveTo)"
                >
                  <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                </button>
              }
            </div>
          </div>
        }
      </div>
    </mat-panel-title>

    @if (isCustomDeleted) {
      <svg
        class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
      </svg>
    }
  </mat-expansion-panel-header>

  <div class="flex flex-1 gap-3" [formGroup]="form()">
    <div class="flex w-9" [class.opacity-50]="(isCustomDeleted || form().disabled) && !isViewMode()">
      <div
        matTooltipPosition="above"
        [matTooltip]="
          'pages.campaignForm.ctaDialog.ctaDetails.deliverables.gamePlayDeliverable.previewTooltip' | translate
        "
      >
        @if (gameImageUrl() && gameImageUrl() !== '-' && !form().get('gameName')?.errors) {
          <img [src]="gameImageUrl()" alt="Game Preview" class="w-[36px] h-[48px] object-cover rounded-lg" />
        } @else if (
          form().get('boxArtUrl')?.value && (gameImageUrl() !== '-' || isViewMode()) && !form().get('gameName')?.errors
        ) {
          <img
            [src]="form().get('boxArtUrl')?.value"
            alt="Game Preview"
            class="w-[36px] h-[48px] object-cover rounded-lg"
          />
        } @else {
          <div class="w-[36px] h-[48px] bg-shikenso-gray-300 rounded-lg flex justify-center items-center">
            <app-icon src="/icons/image-placeholder.svg" alt="Game Preview" class="w-10 h-10 opacity-50" />
          </div>
        }
      </div>
    </div>

    <div class="flex flex-1 gap-3">
      <mat-form-field
        class="w-full"
        matTooltipPosition="above"
        [matTooltip]="
          isViewMode()
            ? form().get('gameName')?.value
            : isCustomMode()
              ? ('pages.campaignForm.ctaDialog.ctaDetails.deliverables.gamePlayDeliverable.noCustomValueAllowed'
                | translate)
              : ''
        "
        [class.custom-value-border]="isCustomMode() && (getCustomValueState('gameName') || form().value.exclusiveTo)"
      >
        <mat-label>
          {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.gamePlayDeliverable.name' | translate }}
        </mat-label>
        <input
          matInput
          formControlName="gameName"
          [placeholder]="
            'pages.campaignForm.ctaDialog.ctaDetails.deliverables.gamePlayDeliverable.placeholder' | translate
          "
          [matAutocomplete]="gameAuto"
          (input)="onGameInputChange()"
          (focus)="onGameInputFocus()"
          (blur)="onGameInputBlur()"
          (click)="$event.stopPropagation()"
        />
        <mat-autocomplete
          #gameAuto="matAutocomplete"
          [hideSingleSelectionIndicator]="true"
          (opened)="onAutocompleteOpened()"
          (optionSelected)="$event.option.value && onGameSelected($event.option.value)"
          autoActiveFirstOption
        >
          @if (isGamesLoading() && !store.loadingMoreGames$()) {
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <mat-option disabled>
                <div class="flex items-center gap-2">
                  <ngx-skeleton-loader class="w-6 h-8" [theme]="{ width: '24px', height: '32px' }" />
                  <ngx-skeleton-loader class="w-32 h-4" [theme]="{ width: '128px', height: '20px' }" />
                </div>
              </mat-option>
            }
          }

          @for (game of games(); track game.id) {
            <mat-option [value]="game" [class.mdc-list-item--selected]="form().get('gameName')?.value === game.name">
              <div class="flex items-center gap-2">
                @if (game.coverUrlFormatted) {
                  <img [src]="game.coverUrlFormatted" alt="cover" class="w-6 h-8 object-cover rounded" />
                } @else {
                  <div class="w-6 h-8 bg-shikenso-gray-300 rounded flex justify-center items-center">
                    <app-icon src="/icons/image-placeholder.svg" alt="cover" class="w-4 h-4 opacity-50" />
                  </div>
                }
                <span>{{ game.name }}</span>
              </div>
            </mat-option>
          }

          @if (games().length && isGamesLoading()) {
            <mat-option disabled>
              <div class="flex justify-center items-center w-full">
                <app-dots-spinner class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
              </div>
            </mat-option>
          }

          @if (!isGamesLoading() && games().length === 0) {
            <mat-option disabled>
              {{ 'shared.noResults' | translate }}
            </mat-option>
          }
        </mat-autocomplete>
        <mat-error [control]="form().get('gameName')" />
        <div matSuffix class="flex gap-1 items-center">
          @if (isCustomMode() && !isViewMode() && getCustomValueState('gameName') && !form().value.exclusiveTo) {
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="isCustomDeleted"
              (click)="onRevertToGlobalClick('gameName')"
            >
              <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
            </button>
          }
        </div>
      </mat-form-field>

      <mat-form-field
        class="w-full"
        [class.custom-value-border]="isCustomMode() && (getCustomValueState('duration') || form().value.exclusiveTo)"
      >
        <mat-label>
          {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.gamePlayDeliverable.duration' | translate }}
        </mat-label>
        <input matInput type="text" formControlName="duration" numberOnly />
        <div matSuffix class="flex gap-1 items-center">
          <span class="text-[10px]">{{ 'shared.timeSuffixLong.minutes' | translate }}</span>

          @if (isCustomMode() && !isViewMode() && getCustomValueState('duration') && !form().value.exclusiveTo) {
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="isCustomDeleted"
              (click)="onRevertToGlobalClick('duration')"
            >
              <app-icon src="/icons/rotate-360.svg" alt="info" class="w-4 h-4" />
            </button>
          }
        </div>
        <mat-error [control]="form().get('duration')" />
      </mat-form-field>
    </div>
  </div>

  @if (showAdvancedSettings() && !isViewMode()) {
    <div class="pl-3 mt-4">
      <app-deliverable-advanced-settings-section
        [form]="form()"
        [platformFeature]="platformFeature()"
        [deliverableType]="form().value.type"
        [isCustomMode]="isCustomMode()"
        [creatorId]="creatorId()"
      />
    </div>
  }
</mat-expansion-panel>
